import DateRangePicker from '../../../../DateRangePicker/DateRangePicker';
import React, { useState } from 'react';
import moment from 'moment';
import { useQueryBuilder } from '../context/QueryBuilderContext';
import { FILTER_OPERATORS } from '../../../utils/constants';
import { parseUpdatedAtConditions } from './FilterUtils';
import ActionButtons from './ActionButtons';

const LastModifiedAtFilterDropdown: React.FC<{ closeDropdown: () => void }> = ({ closeDropdown }) => {
  const { setCondition, removeCondition, getConditionValue } = useQueryBuilder();

  const condition = getConditionValue('updated_at') ?? [];
  const conditions = condition?.[FILTER_OPERATORS.RANGE] || {};
  const { startDateTemp, endDateTemp } = parseUpdatedAtConditions(conditions);

  const defaultStart = moment().subtract(6, 'days').format('MM-DD-YYYY');
  const defaultEnd = moment().format('MM-DD-YYYY');

  const [startDate, setStartDate] = useState(startDateTemp || defaultStart);
  const [endDate, setEndDate] = useState(endDateTemp || defaultEnd);
  const [wasCleared, setWasCleared] = useState(false);

  const onApplyCustomDateFilter = (value?: { startDate: string; endDate: string }[]) => {
    let start, end;

    if (Array.isArray(value) && value.length) {
      start = moment(value[0].startDate).format('MM-DD-YYYY');
      end = moment(value[0].endDate).format('MM-DD-YYYY');
    } else {
      start = startDate;
      end = endDate;
    }

    setStartDate(start);
    setEndDate(end);

    if (wasCleared) {
      removeCondition('updated_at');
      setWasCleared(false);
    } else {
      setCondition('updated_at', FILTER_OPERATORS.RANGE, {
        $gte: moment(start, 'MM-DD-YYYY').startOf('day').toISOString(),
        $lte: moment(end, 'MM-DD-YYYY').endOf('day').toISOString(),
      });
    }

    closeDropdown();
  };

  const onCancelDateRangePicker = () => {
    closeDropdown();
  };

  const clearAll = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setWasCleared(true);
  };

  return (
    <>
      <div className='CreatedAtFilter'>
        <DateRangePicker
          key={`${startDate}-${endDate}`}
          fromDate={startDate}
          toDate={endDate}
          onSave={onApplyCustomDateFilter}
          onCancel={onCancelDateRangePicker}
          onChange={(value) => {
            if (Array.isArray(value) && value.length) {
              const { startDate: rawStartDate, endDate: rawEndDate } = value[0];
              setStartDate(moment(rawStartDate).format('MM-DD-YYYY'));
              setEndDate(moment(rawEndDate).format('MM-DD-YYYY'));
              setWasCleared(false);
            } else {
              setStartDate('');
              setEndDate('');
            }
          }}
          shouldDateRangePickerOpen={true}
          version='v2'
          inline={true}
          withFilters={true}
          withFooter={false}
        />
      </div>
      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={() => onApplyCustomDateFilter([{ startDate, endDate }])}
      />
    </>
  );
};

export default LastModifiedAtFilterDropdown;
